<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs6 offset-xs2>
        <v-card>
          <v-data-table :headers="headers" :items="orders" :pagination.sync="pagination" :total-items="totalOrders">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.orderCode }}</td>
              <td>{{ props.item.customerID.firstName }} {{ props.item.customerID.lastName }}</td>
              <td align="right">${{ (props.item.subTotal +
                props.item.shipping +
                props.item.insurance +
                props.item.install +
                props.item.measure -
                props.item.discount).toFixed(2) }}</td>
              <td>{{ props.item.date }}</td>
              <td></td>
              <td align="center">
                  <v-btn @click="recoverToQuote(props.item._id)" small>Quote</v-btn>
                  <v-btn @click="recoverToOrder(props.item._id)" small>Order</v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex xs12 md2 left pl-4>
        <v-card>
          <v-card-title>
            <h4>Filter</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <!-- <v-select v-model="enabledUsers" :items="availableUsers" chips clearable label="Filter User" multiple @input="searchQuotes()"></v-select> -->
            <v-select
              v-model="enabledUsers"
              :items="availableUsers"
              label="Filter Users"
              item-value="id"
              item-text="firstName"
              multiple
              menu-props="bottom"
              @input="searchQuotes()"
            ></v-select>
            <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details @change="searchQuotes()"></v-text-field>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import OrderService from '@/services/OrderService'
var xlsx = require('xlsx')
export default {
  name: 'archive',
  data () {
    return {
      orders: [],
      headers: [
        { text: 'Order Code', value: 'orderCode' },
        { text: 'Customer Name', value: 'customerName' },
        { text: 'Total', value: 'total' },
        { text: 'Date', value: 'date' },
        { text: 'Payment Status', value: 'paymentStatus' },
        { text: 'Actions', value: 'actions' }
      ],
      snackbar: false,
      popupText: null,
      pagination: {
        sortBy: 'date',
        descending: true,
        rowsPerPage: 30
      },
      search: '',
      enabledUsers: [],
      availableUsers: [],
      totalOrders: 0
    }
  },
  mounted () {
    this.getQuoteUsers()
    this.getOrders()
  },
  watch: {
    pagination: {
      handler () {
        this.getOrders().then(data => {
          this.orders = data
        })
      },
      deep: true
    }
  },
  methods: {
    async getQuoteUsers () {
      const totalUserResponse = await OrderService.usersQuotes()
      let users = totalUserResponse.data.users
      let temp = []
      let userList = []
      users.map(function (value, key) {
        if (value.createdBy) {
          if (!temp.includes(value.createdBy._id) && value.createdBy.firstName) {
            // console.log(value)
            userList.push({ id: value.createdBy._id, firstName: value.createdBy.firstName })
            temp.push(value.createdBy._id)
          }
        }
        if (value.updatedBy) {
          if (!temp.includes(value.updatedBy._id) && value.updatedBy.firstName) {
            // console.log(value)
            userList.push({ id: value.updatedBy._id, firstName: value.updatedBy.firstName })
            temp.push(value.updatedBy._id)
          }
        }
      })
      this.availableUsers = userList
      // console.log(userList)
    },
    async getOrders () {
      let vm = this
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      // const response = await OrderService.fetchArchivedOrders()
      const response = await OrderService.fetchLimitedArchivedOrders(page, rowsPerPage, this.search, this.enabledUsers)
      this.orders = response.data.orders

      let orders = response.data.orders

      if (this.pagination.sortBy) {
        orders = orders.sort((a, b) => {
          const sortA = a[sortBy]
          const sortB = b[sortBy]

          if (descending) {
            if (sortA < sortB) return 1
            if (sortA > sortB) return -1
            return 0
          } else {
            if (sortA < sortB) return -1
            if (sortA > sortB) return 1
            return 0
          }
        })
      }

      /** For each order, grab the customer details. */
      this.orders.forEach(function (order, index) {
        vm.getItems(index, order._id)
        vm.getFreeSamples(index, order._id)
      })

      const totalResponse = await OrderService.countArchivedOrders(this.search, this.enabledUsers)
      this.totalOrders = totalResponse.data.count

      return orders
    },

    async getItems (orderIndex, id) {
      const response = await OrderService.getItems(id)
      this.$set(this.orders[orderIndex], 'items', response.data.items)
    },

    async getFreeSamples (orderIndex, id) {
      const response = await OrderService.getFreeSamples(id)
      this.$set(this.orders[orderIndex], 'freeSamples', response.data.freeSamples)
    },

    async recoverToOrder (id) {
      // Update order status
      const response = await OrderService.updateOrderStatus(id, 'Processing')
      if (response.data.success) {
        this.snackbar = true
        this.popupText = `Order '${response.data.order.orderCode}' recovered successfully.`
      } else {
        this.snackbar = true
        this.popupText = response.data.message
      }
    },
    async searchQuotes () {
      this.orders = await this.getOrders()
    },
    async recoverToQuote (id) {
      // Update order status
      const response = await OrderService.updateOrderStatus(id, 'Quote')
      if (response.data.success) {
        this.snackbar = true
        this.popupText = `Quote '${response.data.order.orderCode}' recovered successfully.`
      } else {
        this.snackbar = true
        this.popupText = response.data.message
      }
    },

    downloadXLSX () {
      var table = document.getElementById('quoteTable')
      var workbook = xlsx.utils.table_to_book(table, {sheet: 'Quotes'})
      return xlsx.writeFile(workbook, ('Orders.xlsx'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Archive.vue